// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { MessageFeedTemplate } from 'models/shared.models';
import { ASSETS } from '../../../../../../assets/assets';
import { AdditionalValuesComponent } from '../../../../fields/additional-values/additional-values.component';
import { DatePickerComponent } from '../../../../fields/date-picker/date-picker.component';
import { InputTextComponent } from '../../../../fields/input-text/input-text.component';
import { SelectTreeComponent } from '../../../../fields/select-tree/select-tree.component';
import { SelectTreeService } from '../../../../fields/select-tree/select-tree.service';
import { TextareaComponent } from '../../../../fields/textarea/textarea.component';
import { MessageFeedbackComponent } from '../../../../message-feedback/message-feedback.component';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../../../popup-feedback/popup-feedback.directive';
import { EntityFieldsComponent } from '../../sub-form/entity-fields/entity-fields.component';
import { ClaimService } from '../claim.service';
import { clearFields, getField, getValues } from '../helpers/data-values';
import { validateFields } from '../helpers/validate';

@Component({
  selector: 'lbca-claim-new-legal-request',
  templateUrl: './claim-new-legal-request.component.html',
  styleUrls: ['../../sub-form/subform.component.scss', '../claim.component.scss'],
  imports: [
    MessageFeedbackComponent,
    SelectTreeComponent,
    EntityFieldsComponent,
    DatePickerComponent,
    InputTextComponent,
    AdditionalValuesComponent,
    TextareaComponent,
    NgTemplateOutlet,
    IconComponent,
  ],
})
export class ClaimNewLegalRequestComponent implements OnInit {
  readonly assets = inject(ASSETS);
  public submitButtonRegisterClaim: boolean = false;

  public claimLabelsDict: Object = {};

  public msgRegistrerNewClaim: string = '';

  public contentTypeText: boolean = false;

  public stepCreate: number = 1;

  public messageFeedObject: MessageFeedTemplate = {
    primary: '',
    secondary: '',
    emoji: '',
    type: 'danger',
    show: false,
    autoclose: true,
  };

  public breadcrumbRegister = [];

  public getFieldv: any = getField();

  public readInputTimeOutDebounce;

  public bulletStepThree: boolean = false;

  public loadingTotalInicial: boolean = true;
  public loadingTotalAtualizado: boolean = true;
  public loadingTotalRisco: boolean = true;

  public isDisabled: boolean = false;

  public valTotalInicial: string = '...';
  public valTotalAtualizado: string = '...';
  public valTotalRisco: string = '...';

  private popupFeedController = new PopupInterfaceCommunication();
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );
  @ViewChild('templateClaimRegistered') templateClaimRegistered!: TemplateRef<any>;
  @ViewChild('templateStepRegisteredOrder') templateStepRegisteredOrder!: TemplateRef<any>;

  @Input() taskId;
  @Input() userId;
  @Input() processId;
  @Input() registerPhase;
  @Input() steps;
  @Input() field;
  @Input() currentLegalRequest;
  @Input() valoresRestore;
  @Input() disabled: boolean = true;

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  @Output('realoadDataOutput') realoadDataEmmitter = new EventEmitter();
  @Output('closeModalOutput') closeModalEmmitter = new EventEmitter();

  constructor(
    private claimService: ClaimService,
    private overlay: Overlay,
    public selectTreeService: SelectTreeService
  ) {}

  ngOnInit(): void {
    this.claimLabelsDict = this.assets.labels.components.claim;
    this.msgRegistrerNewClaim = this.claimLabelsDict['registerNewClaim'].split('|');
    clearFields();
  }

  public async createLegalRequest() {
    // cadastro de pedidos
    const taskId = this.taskId;
    const userId = this.userId;
    const processId = this.processId;
    const phaseId = this.registerPhase?.phaseId;
    const steps = this.steps.find((resp) => resp.phaseId === phaseId);

    const incluirFaseAtual = this.getFieldv['faseatual'].value;

    let stepId;

    if (incluirFaseAtual) {
      if (incluirFaseAtual.length > 0) {
        const currentStepIdCreatedAt = this.steps.find(
          (element) => element.id === steps.id
        ).createdAt;
        stepId = this.steps
          .filter((data) => data.createdAt >= currentStepIdCreatedAt)
          .map((retId) => retId.id)
          .reverse();
      }
    }

    if (!stepId && steps?.id) stepId = [String(steps.id)];

    const params: any = {
      taskId,
      processId,
      userId,
    };

    if (stepId) params.stepId = JSON.stringify(stepId);

    this.submitButtonRegisterClaim = true;

    const fields = [
      'primaryValue',
      'primaryIndexId',
      'interestType',
      'interestDateReference',
      'interestPercents',
      'penaltyPercents',
    ];
    let validate = false;

    if (this.contentTypeText) validate = validateFields(['description']);
    else validate = validateFields(fields);

    if (validate) {
      this.submitButtonRegisterClaim = false;
      return;
    }

    const body = getValues();

    this.createService(body, params)
      .then((resp) => {
        this.showStepRegisteredOrder();
        this.realoadDataEmmitter.emit(true);
        this.closeModal();
        this.submitButtonRegisterClaim = false;
      })
      .catch((error) => {
        this.submitButtonRegisterClaim = false;
        return this.defautlFeedbackServerError(error);
      });
  }

  closeModal() {
    this.closeModalEmmitter.emit(true);
  }

  additionalValuesData;

  public async gotoStepCreate(action: string) {
    if (this.stepCreate === 1 && action === 'next') {
      if (validateFields(['typeId'])) return;
    }

    if (this.stepCreate === 2 && action === 'next') {
      if (!this.contentTypeText) {
        if (validateFields(['part', 'dateReference', 'risk'])) return;
      } else {
        if (validateFields(['part', 'dateReference'])) return;
      }
    }

    if (action === 'next' && this.stepCreate < 3) this.stepCreate = this.stepCreate + 1;
    if (action === 'prev' && this.stepCreate > 1) this.stepCreate = this.stepCreate - 1;
    if (action === 'prev' && this.stepCreate === 1) this.resetFieldsModalRegister();

    if (this.stepCreate === 3) {
      this.additionalValuesData = getValues();
      this.bulletStepThree = true;
      [this.loadingTotalInicial, this.loadingTotalAtualizado, this.loadingTotalRisco] = [
        false,
        false,
        false,
      ];
    }
  }

  public async changetypeIdValue($event, field) {
    const update = this.getFieldv['typeId'];
    update.value = $event;
    update.error = [];
    this.fillBreadcrumb(update.value).then(() => {
      this.stepCreate = 2;
    });
  }

  private resetFieldsModalRegister() {
    clearFields();
    [this.loadingTotalInicial, this.loadingTotalAtualizado, this.loadingTotalRisco] = [
      true,
      true,
      true,
    ];
    [this.valTotalInicial, this.valTotalAtualizado, this.valTotalRisco] = ['...', '...', '...'];
    this.stepCreate = 1;
    this.bulletStepThree = false;
  }

  private async fillBreadcrumb(fase: string = ''): Promise<void> {
    const typeId = this.getFieldv['typeId'];
    this.selectTreeService.breadcrumbEntity(typeId.breadcrumbEntity, fase).subscribe(
      (resp: any): void => {
        if (resp) {
          this.breadcrumbRegister = resp.map((tipo) => tipo.label).join(' / ');
          this.getFieldv['typeLabel'].value = this.breadcrumbRegister;
          this.contentTypeText = resp[0].contentTypeText || false;
        }
      },
      (error: any) => {
        return this.defautlFeedbackServerError(error);
      }
    );
  }

  public actionBackRegister($event) {
    this.stepCreate = this.stepCreate - 1;
    if (this.stepCreate < 1) this.closeModalEmmitter.emit(true);
  }

  private async createService(body, params): Promise<any> {
    return new Promise((resolve, reject) => {
      this.claimService.createLegalRequest(body, params).subscribe(
        (response: any) => {
          if (response.errors || response.message) reject(response.errors);
          else resolve(response.id);
        },
        (err: any) => {
          reject(err);
        }
      );
    });
  }

  public changeValueReceiver($event) {
    const value = $event.value;
    const field = $event.entityKey;
    const required = $event.required;

    const campos = this.field.fields.find((i) => i.type === 'ADDITIONAL_VALUES').fields;

    const hasInterestField = campos?.find((item) => item?.entityKey === 'hasInterest');
    const hasPenaltyield = campos?.find((item) => item?.entityKey === 'hasPenalty');
    const interestTypeField = hasInterestField?.fields[0]?.find(
      (item) => item?.entityKey === 'interestType'
    );
    const interestPercentsField = hasInterestField?.fields[1]?.find(
      (item) => item?.entityKey === 'interestPercents'
    );
    const interestDateReferenceField = hasInterestField?.fields[1]?.find(
      (item) => item?.entityKey === 'interestDateReference'
    );

    const yearTwoThousandAndTwo = 1009850400;

    if (field === 'interestDateReference') {
      if (interestTypeField.value === 'legal') {
        interestPercentsField.value = value < yearTwoThousandAndTwo ? '0.5' : '1.0';
      }
    }

    if (field === 'interestType') {
      if (value === 'convencional') {
        interestPercentsField.disabled = false;
        interestPercentsField.value = '';
      }
      if (value === 'legal') {
        interestPercentsField.disabled = true;
        interestPercentsField.value =
          interestDateReferenceField?.value < yearTwoThousandAndTwo ? '0.5' : '1.0';
      }
    }

    campos.forEach((grupos) => {
      grupos.fields.forEach((item) => {
        item.forEach((campo) => {
          if (campo.entityKey === field) {
            this.changeValueNewClaim(value, campo, required);
            grupos.error = [];
          }
        });
      });
    });
  }

  public async changeValueNewClaim(value, field, required = null) {
    field.value = value;
    field.error = [];
    field.required = required;

    const fieldsToListener = [
      'primaryValue',
      'primaryIndexId',
      'dateReference',
      'hasInterest',
      'hasPenalty',
      'interestPercents',
      'interestDateReference',
      'penaltyPercents',
      'interestType',
      'risk',
    ];

    if (fieldsToListener.includes(field.entityKey)) this.callCalc();
  }

  public callCalc() {
    [this.loadingTotalInicial, this.loadingTotalAtualizado, this.loadingTotalRisco] = [
      true,
      true,
      true,
    ];
    this.claimService.calcValoresCadastroPedidos().then((respPromise: any) => {
      [this.loadingTotalInicial, this.loadingTotalAtualizado, this.loadingTotalRisco] = [
        false,
        false,
        false,
      ];
      this.valTotalInicial = respPromise.valTotalInicial;
      this.valTotalAtualizado = respPromise.valTotalAtualizado;
      this.valTotalRisco = respPromise.valTotalRisco;
    });
  }

  public showClaimRegisteredPopup(): void {
    this.popupFeedController.autoclose = 4000;
    this.popupFeedController.show(this.templateClaimRegistered);
  }

  public closeFeed(): void {
    this.messageFeedObject.show = false;
  }

  private defautlFeedbackServerError(error): boolean {
    this.setFeedback(
      this.claimLabelsDict['error-server-primary'],
      this.claimLabelsDict['error-server-secondary'],
      'emojis-expressionless',
      'danger'
    );
    return false;
  }

  private setFeedback(
    primary: string,
    secondary: string,
    emoji: string,
    type: 'danger' | 'warning' | 'success',
    autoclose = true
  ): void {
    this.messageFeedObject.primary = primary;
    this.messageFeedObject.secondary = secondary;
    this.messageFeedObject.emoji = emoji;
    this.messageFeedObject.type = type;
    this.messageFeedObject.autoclose = autoclose;
    this.messageFeedObject.show = true;
  }

  public showStepRegisteredOrder(): void {
    this.popupFeedController.autoclose = 4000;
    this.popupFeedController.show(this.templateStepRegisteredOrder);
  }
}
